// (function (){
//     'use strict';

//     angular
//         .module('services')
//         .service('CommissionService', CommissionService);

//     CommissionService.$inject = ['$http', 'API_BASE'];

//     function CommissionService ($http, API_BASE) {
//         var service = this;

//         service.getCommissions          = getCommissions;
//         service.getCommissionsByFilter  = getCommissionsByFilter;
//         service.getAllCommissionsType   = getAllCommissionsType;
//         service.saveCommission          = saveCommission;
//         service.updateCommission        = updateCommission;
//         service.destroy                 = destroy;
//         service.authorizeCommission     = authorizeCommission;

//         function getCommissions() {
//             return $http.get(API_BASE + '/commissions');
//         }

//         function getCommissionsByFilter(query) {
//             return $http.get(API_BASE + '/commissions/search',{params:query});
//         }

//         function getAllCommissionsType() {
//             return $http.get(API_BASE + '/commissions/getAllCommissionsType');
//         }

//         function saveCommission (query) {
//             return $http.post(API_BASE + '/commissions/saveCommission', query);
//         }
        
//         function updateCommission (query) {
//             return $http.put(API_BASE + '/commissions/updateCommission', query);
//         }

//         function destroy(commission_id) {
//             return $http.delete(API_BASE + '/commissions/delete',{params:commission_id});
//         }

//         function authorizeCommission(commission_id) {
//             return $http.get(API_BASE + '/commissions/authorize',{params:commission_id});
//         }
//     }
// })();